<template>
  <div class="t-container article">
    <div style="text-align: center; font-size: 35px; color: rgb(199 0 11); font-weight: 600; padding-top: 20px;"><span>{{ $i18n.t(`aboutHWT.three.content1`) }}</span></div>
    <h3 class="article-title"><span>{{ $i18n.t(`aboutHWT.three.content2`) }}</span><span style="width: 100px; height: 3px; background-color: rgb(199 0 11); margin: 0 auto; margin-top: 15px;"></span></h3>
    <img src="https://resources.holowits.com/about/国包分布.png" alt="" style="width: 100%;">
    <p class="text article-content">{{ $i18n.t(`aboutHWT.three.content3`) }}</p>
    <p class="text article-content">{{ $i18n.t(`aboutHWT.three.content4`) }}</p>
    <h3 class="article-title"><span>{{ $i18n.t(`aboutHWT.three.content5`) }}</span><span style="width: 100px; height: 3px; background-color: rgb(199 0 11); margin: 0 auto; margin-top: 15px;"></span></h3>
    <img src="https://resources.holowits.com.sg/about/partner-wall20240729.png" alt="" style="width: 100%;">
    <p class="text article-content">{{ $i18n.t(`aboutHWT.three.content6`) }}</p>
  </div>
</template>

<script>
export default {
    name: 'BusinessOverview',
    data() {
        return {}
    }
}
</script>

<style  lang="less" scoped>
.text {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
}
.article {
    padding: 0 24px 16px;

    .article-title {
    font-size: 40px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    padding: 100px 0 40px;
    span {
        // border-bottom: 2px solid rgb(199 0 11);
        display: block;
        font-size: 28px;
        font-weight: 600;
    }
    }

    .article-content {
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 2.0;
    }
}
</style>